import { action, computed, makeAutoObservable, observable } from "mobx";
import { StoreClass } from "./Store";
import { swalAlert } from "../utils/Swal";
import FabricModel from "../models/FabricModel";

export default class SelectedSwatchesStore {
    store: StoreClass
    @observable swatchesCategoryId = null;
    @observable selectedSwatches = [];
    @computed get swatches() {
        return this.store.fabrics;
    }

    @computed get filteredSwatches(){
        return this.selectedCategory?.fabrics.filter((f) => {
            // var isFromSelectedCategory = f.category === this.swatchesCategoryId;
            var isSelectedColor = true;
            var colorsIds = this.store.fabricFilters.getFilterValue("colors");
            if(colorsIds.length > 0){
                isSelectedColor = f.colorGroupIds.some(id => colorsIds.includes(id));
            }
            return isSelectedColor;
        }) || [];
    }
    
    @computed get unitPrice(){
        if(this.store.sampleFabricProdcut === null){
            return 0;
        }
        
        return this.store.sampleFabricProdcut.price;
        
    }
    @computed get totalPrice(){
        if(this.selectedSwatches.length === 0){
            return 0;
        }
        if(this.store.sampleFabricProdcut === null){
            return 0;
        }
        const amount = this.selectedSwatches.length;
        return amount * this.store.sampleFabricProdcut.price;
        return 0;
    }

    @computed get selectedCategory() {
        return this.store.fabric_collection.find(
            (fc) => fc.id === this.swatchesCategoryId
        );
    }
    constructor({ store }) {
        this.selectedSwatches = [];
        this.store = store;
        makeAutoObservable(this);
    }

    @computed get amount() {
        return this.selectedSwatches.length;
    }


    @action fillFromStore(swatches){
        swatches.forEach((swatch) => {
            const fabric = this.store.fabrics.find((fabric) => {
                const name = String(fabric.name).toLowerCase();
                return String(swatch.variant).toLowerCase().includes(name);
            });
            if(fabric){
                fabric.cartId = swatch.id;
                this.selectedSwatches.push(fabric);
            }
        });
    }

    clear(){
       this.clearSwatches();
        
    }

    /**
     * 
     * @param {FabricModel} swatch 
     */
    @action async addSwatch(swatch) {
       
         try {
            const response = await this.store.cart.addSwatch(swatch);

            if(response.length > 0){
                // debugger;
                swatch.cartId = response[0].id;
                this.selectedSwatches.push(swatch);
            }

        } catch (err) {
            console.error(err);
            swalAlert({
                title: "Błąd",
                html:
                    err.toString()
            })
        }
    }

    /**
     * 
     * @param {FabricModel} swatch 
     * @returns 
     */
    @action async removeSwatch(swatch) {
            
        try {
            const response = await this.store.cart.removeSwatch(swatch);
            
            this.selectedSwatches = this.selectedSwatches.filter(
                (s) => s !== swatch
            );
            
            return response;
        } catch (err) {
            swalAlert({
                title: "Błąd",
                html:
                    err.toString()
            })
        }
        
    }

    @action clearSwatches() {
        this.selectedSwatches = [];
    }
    @action openCategory(id) {
        this.swatchesCategoryId = id;
    }

    includes(swatch) {
        return this.selectedSwatches.includes(swatch) || this.selectedSwatches.map((s) => s.id).includes(swatch.id);
    }
}
